import { NgModule } from '@angular/core';
import { RouterModule, Routes, Resolve } from '@angular/router';

import { navbarRoute } from '../app.route';
import { errorRoute } from './';

let LAYOUT_ROUTES = [
    navbarRoute,
    ...errorRoute
];

@NgModule({
  imports: [
    RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true })
  ],
  exports: [
    RouterModule
  ]
})
export class LayoutRoutingModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/layout-routing.module.ts